import React from "react";

export const PaymentPending = () => {
  setTimeout(() => {
    window.location.href = "/";
  }, 5000);
  return (
    <div
      className="container d-flex flex-column justify-content-center align-items-center text-center"
      style={{ minHeight: "80vh" }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        fill="none"
        viewBox="0 0 24 24"
        stroke="orange"
        strokeWidth="2"
        className="mb-4"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>

      <h1 className="display-5 fw-bold text-warning mb-3">Payment Pending</h1>
      <p className="lead text-muted">
        Your transaction is being processed. Please wait while we confirm the
        payment.
      </p>
    </div>
  );
};